import styled from "styled-components";

export const Li = styled.li`
  height: 35px;
  padding-left: ${({ level }) => level * 15}px;
`;
